//#region src/upsize_upsell_display_style.ts
var UpsizeUpsellDisplayStyle = /* @__PURE__ */ function(UpsizeUpsellDisplayStyle) {
	UpsizeUpsellDisplayStyle["Standard"] = "standard";
	UpsizeUpsellDisplayStyle["Comparison"] = "comparison";
	return UpsizeUpsellDisplayStyle;
}(UpsizeUpsellDisplayStyle || {});
//#endregion
export { UpsizeUpsellDisplayStyle };

//# sourceMappingURL=upsize_upsell_display_style.js.map